export default "__VITE_ASSET__VcJbS$Lt__"